import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { Subscription } from "rxjs";
import { LanguagesService } from "src/app/services/languages.service";
import { RegistrationService } from "src/app/services/registration.service";

@Component({
  selector: "app-registration-form",
  templateUrl: "./registration-form.component.html",
  styleUrls: ["./registration-form.component.css"],
})
export class RegistrationFormComponent implements OnInit {
  @Input() inputValue: string;
  chatbot_lang: string;
  medicalIdErrorMessage = "";
  emailErrorMessage = "";
  nameErrorMessage = "";
  subscription: Subscription = new Subscription();
  constructor(
    private formBuilder: FormBuilder,
    private registrationService: RegistrationService,
    private language: LanguagesService
  ) {
    const currentYear = new Date().getFullYear();
    this.maxDate = new Date();
  }
  //--------------------------------------------------------
  ngOnInit() {
    this.subscription = this.language.get_language().subscribe((message) => {
      console.log("message.content",message.content,message);
      console.log("inputValue",this.inputValue)
      if (message.content) {
        this.chatbot_lang = message.content;
      } else {
        this.chatbot_lang = "en";
      }
    });

    console.log("aref",this.registrationForm);
    
  }
  //to get the values of the form
  registrationForm = this.formBuilder.group({
    //mandatory fields:personal info
    language: "",
    firstName: "",
    lastName: "",
    dateOfBirth: new Date (this.registrationService.registrationForm.dateOfBirth.replace(/-/g, '/')),
    phoneNumber: this.registrationService.registrationForm.phoneNumber,
    //optional fields: basic info
    email: "",
    income: "",
    educationLevel: "",
    race: "",
    ethnicity: "",
    //optional fields:housing info
    permanentAddress: "",
    streetAddress: "",
    //optional fields:disability,sex,medicalId
    healthInsurance: "",
    disability: "",
    sex: "",
    medicalId: "",
    servedInArmy: "",
  });

  submitRegistrationForm() {
    if (
      this.registrationForm.value.firstName &&
      this.registrationForm.value.lastName &&
      this.registrationForm.value.dateOfBirth &&
      this.registrationForm.value.phoneNumber &&
      this.registrationForm.value.income>=0 &&
      this.registrationForm.value.race &&
      this.registrationForm.value.ethnicity &&
      this.registrationForm.value.language
    ) {
      if (this.registrationForm.value.medicalId) {
        if (
          this.registrationService.validateMedicalId(
            this.registrationForm.value.medicalId
          )
        ) {
          //to save form data in the registration service and set isRegFormSubmitted to true
          this.registrationService.fillRegForm(this.registrationForm.value);
          console.warn("Your form has been submitted");
          this.medicalIdErrorMessage = "";
        } else {
          console.warn("Enter a valid medical id of 14 characters");
        }
      } else {
        //to save form data in the registration service and set isRegFormSubmitted to true
        this.registrationService.fillRegForm(this.registrationForm.value);
        console.warn("Your form has been submitted");
      }
      //to test entries:
      console.log({
        formContentFromRegistrationComponent: this.registrationForm.value,
      });
    } else {
      console.warn("All required fields must be filled");
    }
  }
  //to ensure that the required fields are filled:
  inputField = new FormControl("", [Validators.required, Validators.email]);
  getErrorMessage() {
    if (this.inputField.hasError("required")) {
      // this.emailErrorMessage =
      //   this.chatbot_lang == "en"
      //     ? "Enter a valid email address"
      //     : "Introduzca una dirección de correo electrónico válida";
      if (this.chatbot_lang == "en") {
        return "You must enter a value";
      } else {
        return "Debes ingresar un valor";
      }
    }
  }
  getErrorMessageDate() {
    if (this.inputField.hasError("required")) {
      // this.emailErrorMessage =
      //   this.chatbot_lang == "en"
      //     ? "Enter a valid email address"
      //     : "Introduzca una dirección de correo electrónico válida";
      if (this.chatbot_lang == "en") {
        return "You must enter the correct date";
      } else {
        return "Debes ingresar la fecha correcta";
      }
    }
  }
  // getErrorMessageEmail() {
  //   if (this.inputField.hasError("required")) {
  //     // this.emailErrorMessage =
  //     //   this.chatbot_lang == "en"
  //     //     ? "Enter a valid email address"
  //     //     : "Introduzca una dirección de correo electrónico válida";
  //     if (this.chatbot_lang == "en") {
  //       return "You must enter the correct email";
  //     } else {
  //       return "Debes ingresar el correo electrónico correcto";
  //     }
  //   }
  // }
  getErrorMessageSelect() {
    if (this.inputField.hasError("required")) {
      // this.emailErrorMessage =
      //   this.chatbot_lang == "en"
      //     ? "Enter a valid email address"
      //     : "Introduzca una dirección de correo electrónico válida";
      if (this.chatbot_lang == "en") {
        return "You must select one of the opstions";
      } else {
        return "Debe seleccionar una de las opciones";
      }
    }
  }
  //date of birth validation:
  maxDate: Date;

  //check if submitting the form is allowed:
  isSubmitFormAllowed() {
    // console.log(
    //   "iiiiiiiiiii",
    //   this.ValidateEmail(this.registrationForm.value.email)
    // );
    // console.log(" this.medicalIdErrorMessage", this.medicalIdErrorMessage);

    console.log("this.registrationForm", this.registrationForm);
     if (this.registrationForm.value.lastName.length ==  0 && this.registrationForm.value.firstName.length == 0){
      this.nameErrorMessage =""
    }
    if (this.registrationForm.value.medicalId) {
      if (
        this.registrationForm.value.firstName ||
        this.registrationForm.value.lastName
      ) {
        if (
         !this.ValidateName(this.registrationForm.value.lastName) ||
          !this.ValidateName(this.registrationForm.value.firstName)
        ) {
          this.nameErrorMessage = 
          this.chatbot_lang == "en"
          ? "Enter a valid name with (a-z / A-Z / À-ž) characters"
          : "Ingrese un nombre válido con (a-z / A-Z / À-ž) caracteres";
      return true;
        }
        else if (this.registrationForm.value.lastName.length ==  0 && this.registrationForm.value.firstName.length == 0){
          this.nameErrorMessage =""
        }
        else{
          this.nameErrorMessage =""
        }
      }
      if (this.registrationForm.value.medicalId.length < 14) {
        if (
          !this.registrationService.validateMedicalId(
            this.registrationForm.value.medicalId
          )
        ) {
          this.medicalIdErrorMessage =
            this.chatbot_lang == "en"
              ? "Enter a valid medical id of 14 characters"
              : "Ingrese una identificación médica válida de 14 caracteres";
          return true;
        } else {
          this.medicalIdErrorMessage = "";
        }
      }
      if (
        this.registrationForm.value.firstName &&
        this.registrationForm.value.lastName &&
        this.registrationForm.value.dateOfBirth &&
        this.registrationForm.value.phoneNumber &&
        this.registrationForm.value.income>=0 &&
        this.registrationForm.value.race &&
        this.registrationForm.value.ethnicity &&
        this.registrationForm.value.language &&
        // this.registrationForm.value.email &&
        this.registrationForm.value.medicalId.length == 14

        // this.registrationForm.value.email.includes(".")
      ) {
        if (this.registrationForm.value.email) {
          if (this.registrationForm.value.email.length <= 0) {
            this.emailErrorMessage =
              this.chatbot_lang == "en"
                ? "Enter a valid email address"
                : "Introduzca una dirección de correo electrónico válida";
            return "You must enter a value";
          } else if (!this.ValidateEmail(this.registrationForm.value.email)) {
            // console.log("in email error msg");

            this.emailErrorMessage =
              this.chatbot_lang == "en"
                ? "Enter a valid email address"
                : "Introduzca una dirección de correo electrónico válida";
            return "You must enter a value";
          } else {
            this.emailErrorMessage = "";
          }
        }
        if (this.registrationForm.value.medicalId) {
          if (
            !this.registrationService.validateMedicalId(
              this.registrationForm.value.medicalId
            )
          ) {
            this.medicalIdErrorMessage =
              this.chatbot_lang == "en"
                ? "Enter a valid medical id of 14 characters"
                : "Ingrese una identificación médica válida de 14 caracteres";
            return false;
          } else {
            this.medicalIdErrorMessage = "";
          }
        }
      } else {
        this.medicalIdErrorMessage = "";
        return true;
      }
    } else {
      if (
        this.registrationForm.value.firstName ||
        this.registrationForm.value.lastName
      ) {
        if (
         !this.ValidateName(this.registrationForm.value.lastName) ||
          !this.ValidateName(this.registrationForm.value.firstName)
        ) {
          this.nameErrorMessage = 
          this.chatbot_lang == "en"
          ? "Enter a valid name with (a-z / A-Z / À-ž) characters"
          : "Ingrese un nombre válido con (a-z / A-Z / À-ž) caracteres";
      return true;
        }
        else if (this.registrationForm.value.lastName.length ==  0 && this.registrationForm.value.firstName.length == 0){
          this.nameErrorMessage =""
        }
        else{
          this.nameErrorMessage =""
        }
      }
      if (this.registrationForm.value.medicalId == "") {
        this.medicalIdErrorMessage = "";
      }
      if (
        this.registrationForm.value.firstName &&
        this.registrationForm.value.lastName &&
        this.registrationForm.value.dateOfBirth &&
        this.registrationForm.value.phoneNumber &&
        this.registrationForm.value.income>=0 &&
        this.registrationForm.value.race &&
        this.registrationForm.value.ethnicity &&
        this.registrationForm.value.language 
        // this.registrationForm.value.email

        // this.registrationForm.value.email.includes(".")
      ) {
        // if (this.registrationForm.value.email) {
        //   if (this.registrationForm.value.email.length <= 0) {
        //     this.emailErrorMessage =
        //       this.chatbot_lang == "en"
        //         ? "Enter a valid email address"
        //         : "Introduzca una dirección de correo electrónico válida";
        //     return "You must enter a value";
        //   } else if (!this.ValidateEmail(this.registrationForm.value.email)) {
        //     // console.log("in email error msg 2");

        //     this.emailErrorMessage =
        //       this.chatbot_lang == "en"
        //         ? "Enter a valid email address"
        //         : "Introduzca una dirección de correo electrónico válida";
        //     return "You must enter a value";
        //   } else {
        //     this.emailErrorMessage = "";
        //   }
        // }
        if (this.registrationForm.value.medicalId) {
          if (
            !this.registrationService.validateMedicalId(
              this.registrationForm.value.medicalId
            )
          ) {
            this.medicalIdErrorMessage =
              this.chatbot_lang == "en"
                ? "Enter a valid medical id of 14 characters"
                : "Ingrese una identificación médica válida de 14 caracteres";
            return true;
          } else if (this.registrationForm.value.medicalId.length < 14) {
            this.medicalIdErrorMessage =
              this.chatbot_lang == "en"
                ? "Enter a valid medical id of 14 characters"
                : "Ingrese una identificación médica válida de 14 caracteres";
            return true;
          } else {
            this.medicalIdErrorMessage = "";
          }
        }
      } else {
        this.medicalIdErrorMessage = "";
        return true;
      }
    }
  }
  ValidateEmail(mail: string) {
    // console.log("in validate email");

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }
  ValidateName(name) {
    // console.log("in validate name");
    if (/^[a-zA-Z_À-ž\s]*$/.test(name)) {
      return true;
    }
    return false;
  }
}
